// import { message } from 'antd';
import { setErrorReducer, setRequestReducer, setSuccessReducer } from '../helper';
import actions from './actions';

const initialState = {
    searchMsicCodeState: false,
    // searchMsicCodeErrorMsg: null,
    searchMsicCodeResult: null,

    searchClassificationCodeState: false,
    searchClassificationCodeResult: null,
};

export default function appReducer(state = initialState, action = {}) {
    switch (action.type) {
        case actions.AI_SEARCH_MSIC_CODE_REQUEST:
            return setRequestReducer(state, 'searchMsicCodeState');
        case actions.AI_SEARCH_MSIC_CODE_SUCCESS: {
            // if (action.errorMsg)
            //     message.error(action.errorMsg);

            return setSuccessReducer(state, 'searchMsicCodeState', {
                searchMsicCodeResult: action.msicCode,
                // searchMsicCodeErrorMsg: action.errorMsg,
            });
        }
        case actions.AI_SEARCH_MSIC_CODE_ERROR:
            return setErrorReducer(state, 'searchMsicCodeState', {
                searchMsicCodeResult: null,
            });

        case actions.AI_SEARCH_CLASSIFICATION_CODE_REQUEST:
            return setRequestReducer(state, 'searchClassificationCodeState');
        case actions.AI_SEARCH_CLASSIFICATION_CODE_SUCCESS: {
            return setSuccessReducer(state, 'searchClassificationCodeState', {
                searchClassificationCodeResult: action.classificationCode,
            });
        }
        case actions.AI_SEARCH_CLASSIFICATION_CODE_ERROR:
            return setErrorReducer(state, 'searchClassificationCodeState', {
                searchClassificationCodeResult: null,
            });

        default:
            return state;
    }
}
